import { FunctionComponent } from "react";

import { FontSizes, PrimaryButton, Stack, Text } from "@bps/fluent-ui";
import { useFormContext } from "@bps/form-api";

import { ErrorResult } from "../../api/base";
import { FormStatusEnum } from "../../hooks/useFormApi.types";
import { VerifyPinFormValues } from "./VerifyPinForm.interface";
import { VerifyPinFormInputs } from "./VerifyPinFormInputs";

interface VerifyPinFormFieldsProps {
  error: ErrorResult | undefined;
}

export const VerifyPinFormFields: FunctionComponent<
  VerifyPinFormFieldsProps
> = ({ error }) => {
  const { actions, state } = useFormContext<VerifyPinFormValues>();

  return (
    <Stack tokens={{ childrenGap: 24 }}>
      <Stack tokens={{ childrenGap: 12 }}>
        <VerifyPinFormInputs isError={!!error} />
        <Text
          styles={{
            root: {
              fontSize: FontSizes.size12,
              padding: 8,
              borderRadius: 4,
              backgroundColor: "rgba(36, 110, 201, 0.1)"
            }
          }}
        >
          <strong>Eg:</strong> 10/12/1993 becomes 10/12/93
        </Text>
      </Stack>
      <PrimaryButton
        styles={{ root: { height: 56, padding: "6px 20px" } }}
        onClick={() => actions.submit()}
        disabled={
          !!state.invalid || error?.status === FormStatusEnum.TooManyAttempts
        }
      >
        Continue
      </PrimaryButton>
    </Stack>
  );
};
